import type { FC } from "react";

import { cn } from "@/lib/utils";

interface LabelWithOptionalProps {
  label: string;
  classes?: string;
  optionalClasses?: string;
}

const LabelWithOptional: FC<LabelWithOptionalProps> = ({
  label,
  classes,
  optionalClasses,
}) => (
  <div className="flex items-center gap-1">
    <span className={classes}>{label}</span>
    <span className={cn("text-gray-300", classes, optionalClasses)}>
      (optional)
    </span>
  </div>
);

export default LabelWithOptional;
